<div class="popover-header">
  <div class="popover-title">{{ LL.mealPlan.copyDialog.title() }}</div>
  <div class="popover-close" (click)="handleClose()">
    <cs-icon name="close"></cs-icon>
  </div>
</div>

<div class="popover-message">
  {{ LL.mealPlan.copyDialog.message({ meals: input?.mealDescription }) }}
</div>

<div class="day-selection">
  <!-- Select All -->
  <div class="select-all-row">
    <cs-checkbox [checked]="selectAll" (checkedChange)="handleSelectAllChange($event)"></cs-checkbox>
    <span class="checkbox-label">{{ LL.mealPlan.copyDialog.selectAll() }}</span>
  </div>

  <div class="divider"></div>

  <!-- Day checkboxes in two columns -->
  <div class="days-grid">
    <div class="days-column">
      @for (day of leftColumnDays; track day) {
        <div class="day-row">
          <cs-checkbox [checked]="day.checked" (checkedChange)="handleDayChange(day, $event)"></cs-checkbox>
          <span class="checkbox-label">{{ day.label }}</span>
        </div>
      }
    </div>
    <div class="days-column">
      @for (day of rightColumnDays; track day) {
        <div class="day-row">
          <cs-checkbox [checked]="day.checked" (checkedChange)="handleDayChange(day, $event)"></cs-checkbox>
          <span class="checkbox-label">{{ day.label }}</span>
        </div>
      }
    </div>
  </div>
</div>

<div class="popover-buttons">
  <cs-button medium secondary (click)="handleCancel()">
    {{ LL.common.buttons.cancel() }}
  </cs-button>
  <cs-button medium primary [disabled]="!hasSelection" (click)="handleCopy()">
    {{ LL.mealPlan.copyDialog.copyButton() }}
  </cs-button>
</div>
